import userReducers from "./userReducers";

const rootReducer = {
    user: userReducers
};

export default rootReducer;